import React from 'react';
import { Controller } from 'react-hook-form';
import { formatNumberLength } from '../../helpers';

//Componentes
import TableContainer from '../../components/table/TableContainer';
import ReactDatePicker from 'react-datepicker';

//Estilos
import './NewGuia.css';
import dayjs from 'dayjs';

function NewGuia({ functions, states }) {
    const {
        user,
        localeDateFormat,
        ItemsProductorTableData,
        ItemsBodegaTableData,
        GuiaData,
        Bodegas,
        EstadoDestinatario,
        EstadoCerrada,
        EstadoCreada,
        CurrentBodega,
        masters,
        grapesVariety,
    } = states;

    const {
        control,
        watch,
        register,
        getValues,
        setValue,
        handleSubmit,
        formState: { errors },
        buildSelectOptions,
        formatNumber,
        onSubmit,
        setOpenConfirmGuiaModal,
        setOpenDeleteGuiaModal,
    } = functions;

    return (
        <div className="new_guia-container">
            <h4 className="new_guia-title">
                Guía {GuiaData?.cabecera?.serie}-G-
                {formatNumber(GuiaData?.cabecera?.numero)}
            </h4>
            <form className="new_guia-form" onSubmit={handleSubmit(onSubmit)}>
                {EstadoCreada ? (
                    <>
                        {' '}
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Matrícula Vehículo: </span>
                                <input
                                    type="text"
                                    {...register(
                                        'cabecera.matricula_Vehiculo',
                                        {
                                            require:
                                                'Ingrese una matrícula de transporte',
                                        }
                                    )}
                                    onKeyPress={(e) => {
                                        if (e.target.value.length > 8) {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={EstadoDestinatario}
                                />
                            </div>
                            {errors.cabecera?.matricula_Vehiculo && (
                                <small className="form__error">
                                    {
                                        errors.cabecera?.matricula_Vehiculo
                                            ?.message
                                    }
                                </small>
                            )}
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Guía papel: </span>
                                <input
                                    type="text"
                                    {...register('cabecera.guia_Papel')}
                                    onKeyPress={(e) => {
                                        if (e.target.value.length > 9) {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={EstadoDestinatario}
                                />
                            </div>
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Bodega Destino: </span>
                                <select
                                    disabled={EstadoDestinatario}
                                    {...register('cabecera.bodega_Id')}
                                >
                                    <option value={0}>Ninguna</option>
                                    {Bodegas?.map((b) => {
                                        return (
                                            <option key={b.id} value={b.id}>
                                                {b.razon_social}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                            {errors.cabecera?.bodega_Id && (
                                <small className="form__error">
                                    {errors.cabecera?.bodega_Id?.message}
                                </small>
                            )}
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Titular Destinatario: </span>
                                <input
                                    type="text"
                                    {...register(
                                        'cabecera.titular_Destinatario',
                                        {
                                            require:
                                                'Ingrese un titular destinatario',
                                        }
                                    )}
                                    onKeyPress={(e) => {
                                        if (e.target.value.length > 50) {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={
                                        EstadoDestinatario || CurrentBodega != 0
                                    }
                                />
                            </div>
                            {errors.cabecera?.titular_Destinatario && (
                                <small className="form__error">
                                    {
                                        errors.cabecera?.titular_Destinatario
                                            ?.message
                                    }
                                </small>
                            )}
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Ubicación Destinatario: </span>
                                <input
                                    type="text"
                                    {...register(
                                        'cabecera.ubicacion_Destinatario',
                                        {
                                            require:
                                                'Ingrese una ubicación de destino',
                                        }
                                    )}
                                    onKeyPress={(e) => {
                                        if (e.target.value.length > 100) {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={
                                        EstadoDestinatario || CurrentBodega != 0
                                    }
                                />
                            </div>
                            {errors.cabecera?.ubicacion_Destinatario && (
                                <small className="form__error">
                                    {
                                        errors.cabecera?.ubicacion_Destinatario
                                            ?.message
                                    }
                                </small>
                            )}
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Depto. Destinatario</span>
                                <select
                                    disabled={
                                        EstadoDestinatario || CurrentBodega != 0
                                    }
                                    {...register(
                                        'cabecera.departamento_Destinatario',
                                        {
                                            require:
                                                'Ingrese un departamento destino',
                                        }
                                    )}
                                >
                                    <option value={0}>
                                        Elija Departamento
                                    </option>
                                    {buildSelectOptions('Departments')?.map(
                                        (op) => {
                                            return (
                                                <option
                                                    key={op.name}
                                                    value={op.value}
                                                >
                                                    {op.title}
                                                </option>
                                            );
                                        }
                                    )}
                                </select>
                            </div>
                            {errors.cabecera?.departamento_Destinatario && (
                                <small className="form__error">
                                    {
                                        errors.cabecera
                                            ?.departamento_Destinatario?.message
                                    }
                                </small>
                            )}
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Fecha de Envío: </span>
                                <Controller
                                    name="cabecera.fecha_Envio"
                                    control={control}
                                    render={() => (
                                        <ReactDatePicker
                                            dateFormat={'dd/MM/yyyy'}
                                            isClearable
                                            placeholderText="dd/mm/aaaa"
                                            locale={localeDateFormat}
                                            selected={
                                                getValues(
                                                    'cabecera.fecha_Envio'
                                                )
                                                    ? dayjs(
                                                          getValues(
                                                              'cabecera.fecha_Envio'
                                                          )
                                                      ).toDate()
                                                    : null
                                            }
                                            onChange={(date) =>
                                                setValue(
                                                    'cabecera.fecha_Envio',
                                                    date
                                                )
                                            }
                                            disabled={EstadoDestinatario}
                                        />
                                    )}
                                    rules={{
                                        require: 'Ingrese una fecha de envío',
                                    }}
                                />
                            </div>
                            {errors.cabecera?.fecha_Envio && (
                                <small className="form__error">
                                    {errors.cabecera?.fecha_Envio?.message}
                                </small>
                            )}
                        </label>
                        <label className="new_guia-label">
                            <div className="new_guia-input_container">
                                <span>Destino: </span>
                                <select
                                    disabled={EstadoDestinatario}
                                    {...register('cabecera.destino', {
                                        require: 'Ingrese un destino',
                                    })}
                                >
                                    <option value={0}>Ninguno</option>
                                    {buildSelectOptions('Destinos')?.map(
                                        (op) => {
                                            return (
                                                <option
                                                    key={op.name}
                                                    value={op.value}
                                                >
                                                    {op.title}
                                                </option>
                                            );
                                        }
                                    )}
                                </select>
                            </div>
                            {errors.cabecera?.destino && (
                                <small className="form__error">
                                    {errors.cabecera?.destino?.message}
                                </small>
                            )}
                        </label>
                        <TableContainer tableData={ItemsProductorTableData} />
                    </>
                ) : (
                    <>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Habilitada: </span>
                                <p>
                                    {GuiaData?.cabecera?.estado ? 'SI' : 'NO'}
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Matrícula Transporte: </span>
                                <p>{GuiaData?.cabecera?.matricula_Vehiculo}</p>
                            </div>
                        </label>
                        {GuiaData?.cabecera?.guia_Papel ? (
                            <label className="new_guia-label-destinatario">
                                <div>
                                    <span>Guía papel: </span>
                                    <p>{GuiaData?.cabecera?.guia_Papel}</p>
                                </div>
                            </label>
                        ) : null}
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Viñedo: </span>
                                <p>{GuiaData?.cabecera?.viniedo}</p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Titular Viñedo: </span>
                                <p>{GuiaData?.cabecera?.titular_Viniedo}</p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Titular destinatario: </span>
                                <p>
                                    {GuiaData?.cabecera?.titular_Destinatario}
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Tipo documento: </span>
                                <p>
                                    {
                                        masters.DocumentTypes?.find(
                                            (ht) =>
                                                ht.id ===
                                                GuiaData?.cabecera?.doc_id_tipo
                                        )?.nombre
                                    }
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Número Documento: </span>
                                <p>{GuiaData?.cabecera?.doc_id}</p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Ubicación viñedo: </span>
                                <p>
                                    Latitud:{' '}
                                    {formatNumberLength(
                                        GuiaData?.cabecera?.ubicacion_Viniedo_x
                                    )}
                                    , Longitud:{' '}
                                    {formatNumberLength(
                                        GuiaData?.cabecera?.ubicacion_Viniedo_y
                                    )}
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Depto. viñedo: </span>
                                <p>
                                    {GuiaData?.cabecera?.departamento_Viniedo}
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Ubicación destinatario: </span>
                                <p>
                                    {GuiaData?.cabecera?.ubicacion_Destinatario}
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Depto. destinatario: </span>
                                <p>
                                    {masters?.Departments?.find(
                                        (d) =>
                                            d.id ===
                                            GuiaData?.cabecera
                                                ?.departamento_Destinatario
                                    )?.nombre.replaceAll('_', ' ')}
                                </p>
                            </div>
                        </label>
                        <label className="new_guia-label-destinatario">
                            <div>
                                <span>Destino: </span>
                                <p>
                                    {masters?.Destinos?.find(
                                        (d) =>
                                            d.id === GuiaData?.cabecera?.destino
                                    )?.nombre.replaceAll('_', ' ')}
                                </p>
                            </div>
                        </label>
                        <h4 className="new_guia-title">Uva Enviada</h4>
                        <section className="guia-info-section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Variedad</th>
                                        <th>Kilos Ingresados</th>
                                        <th>Precio Kg</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {GuiaData?.itemsProductor?.map((it, i) => {
                                        return (
                                            <tr key={i}>
                                                <td>
                                                    {
                                                        grapesVariety?.find(
                                                            (gv) =>
                                                                gv.codigo ===
                                                                it.variedad
                                                        )?.variedad
                                                    }
                                                </td>
                                                <td>{it.kilos} kg</td>
                                                <td>${it.precio_Kg}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </section>
                    </>
                )}
                {EstadoDestinatario && (
                    <TableContainer tableData={ItemsBodegaTableData} />
                )}
                <div className="new_guia-footer">
                    {!EstadoDestinatario && (
                        <button
                            type="submit"
                            className="btn btn-primary btn-submit-new_guia"
                        >
                            Guardar
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setOpenConfirmGuiaModal(true)}
                    >
                        {!EstadoDestinatario ? 'Firmar Guía' : 'Cerrar Guía'}
                    </button>
                    {user.tipo != 3 && !EstadoCerrada && (
                        <button
                            className="btn btn-primary"
                            type="button"
                            onClick={() => setOpenDeleteGuiaModal(true)}
                        >
                            Borrar
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
}

export default NewGuia;
